<template>
    <div />
</template>

<script lang="ts">
    import {Component, Vue} from 'vue-facing-decorator'

    @Component({})
    export class RecentViews extends Vue {}

    export default RecentViews
</script>
